import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Truck, Package, Headphones, CreditCard, Building, Users } from 'lucide-react';

const ServicesPage = () => {
  const services = [
    {
      icon: Building,
      title: 'B2B Wholesale Supply',
      desc: 'We provide bulk materials at highly competitive rates for contractors, developers, and corporate clients. Dedicated account managers ensure your supply chain never stops.'
    },
    {
      icon: Truck,
      title: 'Nationwide Delivery',
      desc: 'Fast and reliable logistics network covering all Emirates. We handle heavy machinery, delicate sanitaryware, and bulk materials with utmost care.'
    },
    {
      icon: Package,
      title: 'Project Procurement',
      desc: 'End-to-end procurement services for mega-projects. Send us your BOQ (Bill of Quantities) and we will source, consolidate, and deliver everything you need.'
    },
    {
      icon: CreditCard,
      title: 'Corporate Credit Facilities',
      desc: 'Flexible payment terms and credit facilities for approved B2B partners to help manage project cash flows efficiently.'
    },
    {
      icon: Headphones,
      title: 'Technical Support',
      desc: 'Our experienced team provides technical guidance on product selection, compliance with UAE standards, and installation best practices.'
    },
    {
      icon: Users,
      title: 'Retail Showroom',
      desc: 'Visit our comprehensive showroom in Dubai to experience our products firsthand. Perfect for homeowners and independent contractors.'
    }
  ];

  return (
    <div className="min-h-screen bg-background pb-20">
      {/* Header Banner */}
      <div className="bg-[#0c1b44] text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" />
        <div className="container mx-auto px-4 text-center relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Our Services</h1>
          <p className="text-gray-300 max-w-2xl mx-auto text-lg leading-relaxed">
            Beyond just products, we deliver comprehensive supply chain solutions tailored for the demanding GCC market.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16 max-w-7xl">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, idx) => (
            <Card key={idx} className="border border-gray-100 shadow-sm hover:shadow-xl hover:border-[#0c1b44]/20 transition-all duration-300 group">
              <CardContent className="p-8">
                <div className="w-14 h-14 rounded-xl bg-gray-50 group-hover:bg-[#0c1b44] transition-colors flex items-center justify-center mb-6">
                  <service.icon className="h-7 w-7 text-[#0c1b44] group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-bold text-navy mb-4">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.desc}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Call to action */}
        <div className="mt-20 bg-gray-50 rounded-2xl p-10 text-center border border-gray-100">
          <h2 className="text-2xl md:text-3xl font-bold text-navy mb-4">Need a Custom Procurement Solution?</h2>
          <p className="text-gray-600 max-w-2xl mx-auto mb-8">
            Our team is ready to analyze your project requirements and provide a tailored supply strategy.
          </p>
          <a href="/contact" className="inline-flex items-center justify-center bg-[#0c1b44] hover:bg-[#1a2d64] text-white px-8 py-3 rounded-lg font-semibold transition-colors">
            Contact Our Sales Team
          </a>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
